import React, { useState, useEffect } from "react";
import { List, Button, Space, Divider, Card, Skeleton, Popconfirm, message, Select, Form, Result, Spin, Tooltip, Steps } from 'antd';
import { ArrowLeftOutlined, FileSearchOutlined, } from '@ant-design/icons';
import constants from "../../../constants/constants";
import { fetchAdminApi, fetchApi } from "../../../services/api";
import { useLocation, useNavigate } from "react-router-dom";
import { getColorClass } from "../../../functions/functions";
import { Chart } from "react-google-charts";
import { useStudentPageHeader } from "../Common/StudentPageHeader";

const TestResults = ({ isAdminView = false }) => {
	const location = useLocation();
	const adminDetails = JSON.parse(sessionStorage.getItem("testData"));
	const data = location.state ?? adminDetails;
	const navigate = useNavigate();
	const [correctAnswers, setCorrectAnswers] = useState(0);
	const [totalPoints, setTotalPoints] = useState(0);
	const [date, setDate] = useState("");
	const [correctQuestions, setCorrectQuestions] = useState(0);
	const graphOption = {
		colors: ["#2F8548", "#B91919"],
		backgroundColor: { fill: 'transparent' },
		chartArea: { width: "70%" },
	};
	useStudentPageHeader({
		show: !isAdminView,
		chapterId: data?.chapter_id,
		chapterName: data?.chapter_name,
	}, [isAdminView, data?.chapter_id, data?.chapter_name]);
	useEffect(() => {
		getTestResults()
	}, []);
	const getTestResults = () => {
		const apiFunc = isAdminView ? fetchAdminApi : fetchApi;
		const url = isAdminView
			? `/test-score-admin/${data?.scoreCardId}`
			: `/test-score/${data?.scoreCardId}`;
			apiFunc(url, "get",)
			.then((res) => {
				if (res && res.code && res.code === 200) {
					let correctTotal = res?.data?.q_correct ? res?.data?.q_correct : 0;
					setCorrectAnswers(correctTotal);
					let totalPoints = res?.data?.points ? res?.data?.points : 0;
					setTotalPoints(totalPoints);
					setDate(res?.data?.dt_completed ? res?.data?.dt_completed : "")
					setCorrectQuestions(res?.data?.correct_questions);
				} else {
					setCorrectAnswers(0);
					setTotalPoints(100);
					setCorrectQuestions(0);
					setDate("");
				}
			});
	}
	const getReviewBreadcrumbTrail = () => {
		if (!Array.isArray(data?.breadcrumbTrail) || data.breadcrumbTrail.length === 0) return undefined;

		return [
			...data.breadcrumbTrail,
			{
				path: "/test-results",
				label: constants.TestResult,
				state: data,
			},
		];
	};
	return (
		<div className="mt-2">
			{isAdminView ? <div
				style={{ backgroundColor: getColorClass(data?.chapter_id, "colorcode") }}
				className='text-white w-12 lg:w-36 roboto-slab font-bold text-4xl flex justify-center items-end pb-3.5 absolute right-0 top-0 h-36'
			>
				{data?.chapter_id}
			</div> : null}
			<div className='container mx-auto'>
				{isAdminView ? <div className='flex justify-between items-center'>
					<h1 style={{ color: getColorClass(data?.chapter_id, "colorcode") }} className='text-base lg:text-2xl underline underline-offset-4 font-extrabold uppercase w-4/5 lg:w-auto m-0'>{data?.chapter_name}</h1>
				</div> : null}
				<Divider className="my-1" />
				<div className={`flex justify-between items-center my-3`}>
					<Space >
						{isAdminView && (<h2 className='font-bold text-xl m-0'>{data?.otherDetails?.name} -</h2>)}
						<h2 className='font-bold text-xl m-0'>Test - Attempt #{data?.attempt}</h2>
					</Space>
					{!isAdminView && (
						<div className="w-1/2">
							<Steps
								current={2}
								items={[
									{
										title: 'Instructions',
									},
									{
										title: 'Take a test',
									},
									{
										title: 'Result',
									},
								]}
							/>
						</div>
					)}
				</div>
				<div>
					<Card bodyStyle={{ backgroundColor: '#FAFAFA' }}>
						<div class="grid grid-cols-1 lg:grid-cols-2 divide-x">
							<div>
								<div className='text-green-700 text-xl font-semibold'>You scored {correctAnswers}/{totalPoints} </div>
								<div className='text-green-700 text-xl font-semibold'>{correctQuestions} questions answered correctly</div>
								<div className="font-semibold text-xl">{"Date: " +date || ""}</div>
								<Chart
									width="100%"
									height="300px"
									chartType="PieChart"
									// loader={<div><p className="pt-4">Loading Chart...</p><Skeleton active/></div>}
									data={[
										["Answered", "Total"],
										["Correct", Number(correctAnswers)],
										["Incorrect", Number(totalPoints) - Number(Number(correctAnswers))],
									]}
									options={graphOption}
								/>
							</div>
							<div className="grid place-content-center place-items-center">
								<div className="grid gap-3 lg:w-56">
									{totalPoints !== correctAnswers ?
										<Button
											className='rounded-lg bg-blue-700 text-white text-left' block
											size="large" icon={<FileSearchOutlined aria-hidden="true"/>}
											onClick={() => {
												const breadcrumbTrail = getReviewBreadcrumbTrail();
												let state = {
													chapter_id: data?.chapter_id,
													attempt: data?.attempt,
													chapter_name: data?.chapter_name,
													score_card_id: data?.scoreCardId,
													review_type: "incorrect",
													...(breadcrumbTrail ? { breadcrumbTrail } : {}),
												}
												let route;
												if(isAdminView){
													route = "/user-review-test";
													state.otherDetails = data?.otherDetails
												}else{
													route = '/review-test';
												}
												navigate( route, { state, replace: true });
											}}
										>{constants.ReviewIncorrect}</Button> : null}
									<Button
										className='rounded-lg bg-blue-700 text-white text-left' block
										size="large" icon={<FileSearchOutlined aria-hidden="true"/>}
										onClick={() => {
											const breadcrumbTrail = getReviewBreadcrumbTrail();
											let state = {
												chapter_id: data?.chapter_id,
												attempt: data?.attempt,
												chapter_name: data?.chapter_name,
												score_card_id: data?.scoreCardId,
												// show_result:"f",
												review_type: "all",
												...(breadcrumbTrail ? { breadcrumbTrail } : {}),
											}
											let route;
											if (isAdminView) {
												route = "/user-review-test";
												state.otherDetails = data?.otherDetails
											} else {
												route = '/review-test';
											}
											navigate( route, { state, replace: true });
										}}
									>{constants.ReviewTest}</Button>
									{
										!isAdminView ?
											<>
												<Button onClick={() => {
													const state = {
														chapter_id: data?.chapter_id
													};
													navigate('/chapter-resources', { state, replace: true });
												}}
													className='rounded-lg bg-blue-700 text-white text-left' block
													size="large" icon={<ArrowLeftOutlined aria-hidden="true"/>}	>{constants.BackToChapter}</Button>
												<Button onClick={() => navigate('/dashboard', { replace: true })} icon={<ArrowLeftOutlined aria-hidden="true"/>} className='rounded-lg bg-blue-700 text-white text-left' block
													size="large">{constants.Dashboard}</Button>
											</>:
											<Button onClick={() => {
												sessionStorage.setItem("selectedSection", 0);
												navigate('/test-result');
											}}
												className='rounded-lg bg-blue-700 text-white text-left' block
												size="large" icon={<ArrowLeftOutlined aria-hidden="true"/>}	>{constants.BackToTestResult}</Button>
									}
								</div>
							</div>
						</div>
					</Card>
				</div>
			</div>
		</div>
	);
};
export default TestResults;
